// UI mirror of operator-bff:GET /v1/disruptions/{urn}/operator-activity@v1 (#813,
// apps/operator-bff/src/modules/operator-activity/operator-activity.types.ts).
// Byte-compatible; do NOT import from operator-bff.

export const OPERATOR_ACTION_KINDS = [
  'checkIn',
  'careOutcome',
  'accommodationOutcome',
  'transportOutcome',
  'conditionSet',
  'responsibleAdultLinked',
  'redeem',
] as const;

export type OperatorActionKind = (typeof OPERATOR_ACTION_KINDS)[number];

export type OperatorActionCounts = Record<OperatorActionKind, number>;

export interface OperatorActivityMark {
  kind: OperatorActionKind;
  at: string;
  operatorUrn: string;
  operatorName: string | null;
  subCaseUrn: string;
  pnr: string;
  paxUrn: string | null;
  value: string | null;
}

export interface OperatorActivityRow {
  operatorUrn: string;
  name: string | null;
  actions: OperatorActionCounts;
  total: number;
  firstAt: string;
  lastAt: string;
  passengers: number;
  pnrs: number;
}

export interface OperatorActivityReport {
  disruptionUrn: string;
  generatedAt: string;
  operators: OperatorActivityRow[];
  marks: OperatorActivityMark[];
  totals: { actions: number; operators: number; passengers: number; checkedIn: number; byAction: OperatorActionCounts };
  unattributed: OperatorActionCounts;
  passengerDriven: { checkIn: number; accommodationOutcome: number };
  firstAt: string | null;
  lastAt: string | null;
  lastPassengerAt: string | null;
  known: { cases: boolean };
}
